<template>
  <div>
      <comment-header
      :fathertitle="fathertitle"
      :childtitle="childtitle"
      :path="path"
      >
      </comment-header>
    <a-card  :bordered="false">
      <div slot="title">
        <span>项目列表</span>
        <a-button type="primary" style="margin-left:20px" icon="plus" @click="add">添加</a-button>
      </div>
      <div class="operate">
        
      </div>
      <div slot="extra">
        <a-input-search style="margin-left: 16px; width: 272px" placeholder="请输入项目名" v-model="queryParam.name"  @search="loadData"/>
      </div>
      <a-list
        size="large"
        :pagination="{
          showSizeChanger: true,
          showQuickJumper: true,
          pageSize: 6,
          total: paging.totalRecords,
          current: paging.pageIndex,
           onChange(page, pageSize) {
            paging.pageIndex = page
            loadData()
          },
        }"
      >
        <a-list-item :key="index" v-for="(item, index) in data">
          <a-list-item-meta :description="item.description">
            <a-avatar slot="avatar" size="large" shape="square" :src="item.avatar" />
            <a slot="title">{{ item.title }}</a>
          </a-list-item-meta>
          <div slot="actions">
            <a @click="edit(item)">编辑</a>
          </div>
          <div slot="actions">
            <a @click="remove(item)">删除</a>
          </div>

          <div class="list-content">
            <div class="list-content-item">
              <span>算法模型</span>
              <p>{{ item.networkModelName }}</p>
            </div>
            <div class="list-content-item">
              <span>创建任务数</span>
              <p>{{ item.createTaskCount }}个</p>
            </div>
            <div class="list-content-item">
              <span>新建资源数</span>
              <p>{{ item.createResourceCount }}个</p>
            </div>
            <div class="list-content-item">
              <span>创建时间</span>
              <p>{{ item.createTime }}</p>
            </div>
          </div>
        </a-list-item>
      </a-list>

      <project-form
        ref="projectForm"
        :title="title"
        :visible="visible"
        :loading="confirmLoading"
        :model="mdl"
        :networkModelList="networkModelList"
        :imageUrl="imageUrl"
        @cancel="handleCancel"
        @ok="handleOk"
        @changeRadio="changeRadio"
      />
    </a-card>
  </div>
</template>

<script>
import CommentHeader from '@components/header'
import Info from '@components/info'
import ProjectForm from './ProjectForm'
import * as projectManagement from '@api/projectManage'
import { requestUrl } from '@utils/request_url'
import * as networkModellManage from '@api/networkmodel_management'
const data = []

export default {
  name: 'ProjectList',
  components: {
    CommentHeader,
    ProjectForm,
    Info
  },
  data () {
    return {
      fathertitle: '训练管理',
      childtitle: '项目管理',
      path: '/train/project-list',
      visible: false,
      confirmLoading: false,
      mdl: null,
      imageUrl: {},
      title: '',
      data,
      queryParam: {
        name: ''
      },
      paging: {
        pageSize: 6,
        totalRecords: 1,
        pageIndex: 1
      },
      networkModelList: []
    }
  },
  methods: {
    add () {
      this.title = '新增'
      this.mdl = {}
      this.imageUrl = {
        url: ''
      }
      this.visible = true
    },
    edit (record) {
      this.title = '编辑'
      this.imageUrl = {
        url: record.avatar
      }
      this.mdl = {
        id: record.id,
        name: record.title,
        memo: record.description,
        networkModelId: record.networkModelId
      }
      this.visible = true
    },
    remove (record) {
       const self = this
      this.$confirm({
        title: `你想要删除此项吗（关联数据也会删除）?`,
        content: `当你点击确认按钮时, 这个对话框将会在删除成功时关闭`,
        okText: '确定',
        cancelText: '取消',
        onOk () {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve()
            }, 500)
          })
            .then((res) => {
              projectManagement.removeProject({ id: record.id }).then((r) => {
                self.loadData()
              })
            })
            .catch(() => console.log('小猪，出错啦，休息会吧!'))
        },
        autoFocusButton: null
      })
      //  projectManagement.removeProject({})
    },
    handleCancel () {
      if (this.$refs.projectForm !== undefined || this.$refs.ProjectForm.form !== undefined) { this.$refs.projectForm.form.resetFields() }
      this.visible = false
      this.confirmLoading = false;
    },
    handleOk () {
      const form = this.$refs.projectForm.form
      this.confirmLoading = true
      const self = this
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          if (self.mdl.id > 0) {
            // 修改 e.g.
            new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve()
              }, 500)
            }).then((res) => {
              projectManagement.updateProject({ ...values,id:self.mdl.id}).then((r) => {
                self.visible = false
                self.confirmLoading = false
                form.resetFields()
                self.loadData()
                self.$message.info('保存成功')
              })
            })
          } else {
            // 新增
            new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve()
              }, 500)
            }).then((res) => {
              projectManagement.addProject({ ...values, icon: self.imageUrl.url }).then((r) => {
                self.visible = false
                self.confirmLoading = false
                form.resetFields()
                self.loadData()
                this.$message.info('新增成功')
              })
            })
          }
        } else {
          this.confirmLoading = false
        }
      })
    },
    loadData () {
      const self = this
      projectManagement
        .getProjectPageList({
          pageIndex: self.paging.pageIndex,
          pageSize: self.paging.pageSize,
          name: self.queryParam.name
        })
        .then((res) => {
          self.data = []
          if (res.data !== undefined && res.data != null && res.data.list.length > 0) {
            self.paging.totalRecords = res.data.totalRecords
            for (let index = 0; index < res.data.list.length; index++) {
              const element = res.data.list[index]
              self.data.push({
                id: element.id,
                title: element.name,
                networkModelName: element.networkModelName,
                avatar: requestUrl + '/' + element.icon,
                description: element.memo,
                createTaskCount: element.createTaskCount,
                createTime: element.createTime,
                createResourceCount: element.createResourceCount,
                networkModelId: element.networkModelId
              })
            }
          }
        })
    },
    initNetworkModelList () {
      const self = this
      var property = self.$refs.projectForm.radioGroup
      var industry = self.$refs.projectForm.radioGroup1
      // projectManagement.getlist({property:property,industry:industry}).then((res) => {
      //   console.log(res)
      //   res.data.forEach((r) => {
      //     self.networkModelList.push({
      //       value: r.id,
      //       text: r.name
      //     })
      //   })
      // })
      
      // 另外版本
      networkModellManage.getAll().then((res) => {
        res.data.forEach((r) => {
          self.networkModelList.push({
            value: r.id,
            text: r.name
          })
        })
      })
    },
    changeRadio(value) {
      this.networkModelList = []
      const self = this
      projectManagement.getlist({property:value.property,industry:value.industry}).then((res) => {
        console.log(res)
        
        res.data.forEach((r) => {
          self.networkModelList.push({
            value: r.id,
            text: r.name
          })
        })
      })
    }
  },
  mounted () {
    this.loadData()
    this.initNetworkModelList()
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss'
</style>
